import { Component, Input } from "@angular/core"

@Component({
    selector: "app-collection-card-poster",
    templateUrl: "./collection-card-poster.component.html",
    styleUrls: ["./collection-card-poster.component.less"],
})
export class CollectionCardPosterComponent {
    @Input() public searchImage = null
    // Deprecated image
    @Input() public posterImage = null
    @Input() public resourceCount = null
    @Input() public alt = null
    @Input() public title = null
    @Input() public gtmPrefix: string = ""
    @Input() public absoluteUrl: string = ""
    @Input() public posterImageDimension?: string = "184px"
    public placeholderImg: string = null

    constructor() {
        this.placeholderImg = require("../../../../../assets/placeholder-image.svg")
    }

    public getCollectionsPosterClass() {
        return `gtm-${this.gtmPrefix}-card`
    }
}
